// extracted by mini-css-extract-plugin
export var active = "_c8-7";
export var container = "_c8-0";
export var evenWidth = "_c8-4";
export var large = "_c8-5";
export var outlet = "_c8-8";
export var slide = "_c8-2";
export var small = "_c8-6";
export var tab = "_c8-3";
export var tabs = "_c8-1";